var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-page" }, [
      _c("div", { staticClass: "logo" }),
      _c("div", { staticClass: "error-wrapper" }, [
        _c("div", { staticClass: "img" }),
        _c("h1", [_vm._v("Forbid")]),
        _c("p", [
          _vm._v("You don't have permission to access this resource / page."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }